module.exports = __webpack_public_path__ + "static/6316-b68ba4942e6c9678fc7e50c8c438e463.png";